import eventOrganizerPathConstants from "../../constants/organizer/event-org-path.contant";
import axios from "../../configs/axios-instances";
import apiPath from "../../constants/api-path.constant";

const programmsOrganizerApi = {
  addEventByOrganiser: ({ payload, success, error }) => {
    const {
      eventManage: { addEventByOrganizer },
    } = eventOrganizerPathConstants;
    axios.postRequest({ path: addEventByOrganizer, payload, success, error });
  },
  addEventByAdmin: ({ payload, success, error }) => {
    const {
      eventManage: { addEventByAdmin },
    } = eventOrganizerPathConstants;
    axios.postRequest({ path: addEventByAdmin, payload, success, error });
  },
  listEventsByOrganizer: ({ payload, success, error }) => {
    const {
      eventManage: { listEventByOrganizer },
    } = eventOrganizerPathConstants;

    axios.postRequest({ path: listEventByOrganizer, payload, success, error });
  },

  updateEvent: ({ event_id, payload, success, error }) => {
    const {
      event: { updateEvent },
    } = apiPath;

    const pathWithParams = `${updateEvent}?id=${event_id}`;

    axios.putRequest({ path: pathWithParams, payload, success, error });
  },
  listCategories: ({ id, type, success, error }) => {
    const {
      categoryManage: { listSeatsCategories },
    } = eventOrganizerPathConstants;
    let pathWithParams = `${listSeatsCategories}?id=${id}`;
    if (type) {
      pathWithParams = `${pathWithParams}&type=${type}`;
    }
    axios.getRequest({
      path: pathWithParams,
      success,
      error,
    });
  },
  getEventCategoriesList: ({ success, error }) => {
    const {
      eventManage: { getEventCategoriesList },
    } = eventOrganizerPathConstants;
    axios.getRequest({ path: getEventCategoriesList, success, error });
  },

  addMovieByOrganiser: ({ payload, success, error }) => {
    const {
      movieManage: { addMovieByOrganizer },
    } = eventOrganizerPathConstants;
    axios.postRequest({ path: addMovieByOrganizer, payload, success, error });
  },

  getMovieListofOrganizer: ({ payload, success, error }) => {
    const {
      movieManage: { listMovieByOrganizer },
    } = eventOrganizerPathConstants;
    axios.postRequest({ path: listMovieByOrganizer, payload, success, error });
  },
  getMovieTicketList: ({ payload, success, error }) => {
    const {
      movieTickets: { ticketList },
    } = apiPath;

    const { movie_id, ticket_id } = payload;

    let pathWithParams = `${ticketList}?movie_id=${movie_id}`;

    if (ticket_id) {
      pathWithParams += `&ticket_id=${ticket_id}`;
    }
    axios.getRequest({ path: pathWithParams, success, error });
  },
  getMovieTicketListAdmin: ({ payload, success, error }) => {
    const {
      movieTickets: { ticketListAdmin },
    } = apiPath;

    const { movie_id, ticket_id, currency_code } = payload;

    let pathWithParams = `${ticketListAdmin}?movie_id=${movie_id}`;

    if (ticket_id) {
      pathWithParams += `&ticket_id=${ticket_id}`;
    }
    if (currency_code) {
      pathWithParams += `&currency_code=${currency_code}`;
    }
    axios.getRequest({ path: pathWithParams, success, error });
  },
  getMovieTicketListPublic: ({ payload, success, error }) => {
    const {
      movieTickets: { ticketListPublic },
    } = apiPath;

    const { movie_id, ticket_id, currency_code } = payload;

    let pathWithParams = `${ticketListPublic}?movie_id=${movie_id}`;

    if (ticket_id) {
      pathWithParams += `&ticket_id=${ticket_id}`;
    }
    if (currency_code) {
      pathWithParams += `&currency_code=${currency_code}`;
    }
    axios.getRequest({ path: pathWithParams, success, error });
  },
  addMovieTicket: ({ payload, success, error }) => {
    const {
      movieTickets: { addMovieTicket },
    } = apiPath;

    axios.postRequest({ path: addMovieTicket, payload, success, error });
  },
  updateMovieTicket: ({ ticket_id, payload, success, error }) => {
    const {
      movieTickets: { updateMovieTicket },
    } = apiPath;

    const pathWithParams = `${updateMovieTicket}?ticket_id=${ticket_id}`;

    axios.putRequest({ path: pathWithParams, payload, success, error });
  },
  getMovieGenerList: ({ success, error }) => {
    const {
      movieManage: { getListMovies },
    } = eventOrganizerPathConstants;
    axios.getRequest({ path: getListMovies, success, error });
  },
  deleteMovieTicket: ({ ticket_id, payload, success, error }) => {
    const {
      movieTickets: { deleteMovieTicket },
    } = apiPath;

    const pathWithParams = `${deleteMovieTicket}`;
    axios.deleteRequest({ path: pathWithParams, payload, success, error });
  },
  getEventList: ({ payload, success, error }) => {
    const {
      event: { getEventList },
    } = apiPath;
    const { event_id } = payload;
    const pathWithParams = `${getEventList}?event_id=${event_id}`;

    axios.getRequest({ path: pathWithParams, success, error });
  },

  getEventImages: ({ payload, success, error }) => {
    const {
      event: { getEventImage },
    } = apiPath;
    const { event_id } = payload;
    const pathWithParams = `${getEventImage}?event_id=${event_id}`;

    axios.getRequest({ path: pathWithParams, success, error });
  },
  updateStatus: ({ payload, success, error }) => {
    const {
      event: { updateStatus },
    } = apiPath;

    const { event_id } = payload;
    const pathWithParams = `${updateStatus}?event_id=${event_id}`;
    axios.putRequest({ path: pathWithParams, success, error });
  },
  updateMovieStatus: ({ payload, success, error }) => {
    const {
      movie: { updateMovieStatus },
    } = apiPath;

    const { movie_id } = payload;
    const pathWithParams = `${updateMovieStatus}?movie_id=${movie_id}`;
    axios.putRequest({ path: pathWithParams, success, error });
  },
  deleteEvent: ({ payload, success, error }) => {
    const {
      event: { deleteEvent },
    } = apiPath;

    const { event_id } = payload;
    const pathWithParams = `${deleteEvent}?event_id=${event_id}`;
    axios.deleteRequest({ path: pathWithParams, success, error });
  },

  addEventTicket: ({ payload, success, error }) => {
    const {
      eventTickets: { addEventTicket },
    } = apiPath;

    axios.postRequest({ path: addEventTicket, payload, success, error });
  },
  updateEventTicket: ({ ticket_id, payload, success, error }) => {
    const {
      eventTickets: { updateEventTicket },
    } = apiPath;

    const pathWithParams = `${updateEventTicket}`;

    axios.putRequest({ path: pathWithParams, payload, success, error });
  },
  getEventTicketListOrganizer: ({ payload, success, error ,final}) => {
    const {
      eventTickets: { ticketListOrg },
    } = apiPath;

    const { event_id, ticket_id, currency } = payload;
    let pathWithParams;

    if (ticket_id) {
      pathWithParams = `${ticketListOrg}?event_id=${event_id}&ticket_id=${parseInt(
        ticket_id,
      )}&currency=${currency}`;
    } else {
      pathWithParams = `${ticketListOrg}?event_id=${event_id}&currency=${currency}`;
    }
    axios.getRequest({ path: pathWithParams, success, error,final });
  },
  getEventTicketListAdmin: ({ payload, success, error }) => {
    const {
      eventTickets: { ticketListAdmin },
    } = apiPath;

    const { event_id, ticket_id, currency } = payload;
    let pathWithParams;
    if (ticket_id) {
      pathWithParams = `${ticketListAdmin}?event_id=${event_id}&ticket_id=${parseInt(
        ticket_id,
      )}&currency=${currency}`;
    } else {
      pathWithParams = `${ticketListAdmin}?event_id=${event_id}&currency=${currency}`;
    }
    axios.getRequest({ path: pathWithParams, success, error });
  },
  getEventTicketList: ({ payload, success, error }) => {
    const {
      eventTickets: { ticketList },
    } = apiPath;

    const { event_id, ticket_id } = payload;
    let pathWithParams;
    if (ticket_id) {
      pathWithParams = `${ticketList}?event_id=${event_id}&ticket_id=${parseInt(
        ticket_id,
      )}`;
    } else {
      pathWithParams = `${ticketList}?event_id=${event_id}`;
    }
    axios.getRequest({ path: pathWithParams, success, error });
  },
  deleteEventTicket: ({ ticket_id, payload, success, error }) => {
    const {
      eventTickets: { deleteTicket },
    } = apiPath;

    const pathWithParams = `${deleteTicket}`;

    axios.deleteRequest({ path: pathWithParams, payload, success, error });
  },
  addMovie: ({ payload, success, error }) => {
    const {
      movie: { addMovie },
    } = apiPath;

    axios.postRequest({ path: addMovie, payload, success, error });
  },
  addAdminMovie: ({ payload, success, error }) => {
    const {
      movie: { addAdminMovie },
    } = apiPath;

    axios.postRequest({ path: addAdminMovie, payload, success, error });
  },
  getMovieId: ({ payload, success, error }) => {
    const {
      movie: { movieId },
    } = apiPath;

    const { id } = payload;

    axios.getRequest({ path: `${movieId}?movie_id=${id}`, success, error });
  },
  deleteMovie: ({ payload, success, error }) => {
    const {
      movie: { deleteMovie },
    } = apiPath;

    const { movie_id } = payload;
    const pathWithParams = `${deleteMovie}`;
    axios.deleteRequest({ path: pathWithParams, payload, success, error });
  },

  updateMovie: ({ movie_id, payload, success, error }) => {
    const {
      movie: { updateMovie },
    } = apiPath;

    const pathWithParams = `${updateMovie}?id=${movie_id}`;

    axios.putRequest({ path: pathWithParams, payload, success, error });
  },

  addTheater: ({ payload, success, error }) => {
    const {
      movie: { addTheater },
    } = apiPath;

    axios.postRequest({ path: addTheater, payload, success, error });
  },
  getTheatersList: ({ payload, success, error }) => {
    const {
      movie: { getTheaters },
    } = apiPath;

    const pathWithParams = `${getTheaters}`;

    axios.getRequest({ path: pathWithParams, success, error });
  },

  deleteTheatre: ({ payload, success, error }) => {
    const {
      movie: { deleteTheatre },
    } = apiPath;

    const { theatre_id } = payload;
    const pathWithParams = `${deleteTheatre}?theatre_id=${theatre_id}`;
    axios.deleteRequest({ path: pathWithParams, success, error });
  },

  addOrganizationAdmin: ({ payload, success, error,final }) => {
    const {
      admin: { addOrganization },
    } = apiPath;

    axios.postRequest({ path: addOrganization, payload, success, error,final });
  },
  getChartKeysList: ({ success, error, final }) => {
    const {
      seatsIO: { listChartKeys },
    } = apiPath;

    axios.getRequest({ path: listChartKeys, success, error, final });
  },
  getEventKeysList: ({ chartKey, success, error, final }) => {
    const {
      seatsIO: { listEventKeys },
    } = apiPath;

    axios.getRequest({
      path: `${listEventKeys}/${chartKey}`,
      success,
      error,
      final,
    });
  },
  addChartKey: ({ payload, success, error, final }) => {
    const {
      seatsIO: { addChartKey },
    } = apiPath;

    axios.postRequest({ path: addChartKey, payload, success, error, final });
  },
  addEventKey: ({ payload, success, error, final }) => {
    const {
      seatsIO: { addEventKey },
    } = apiPath;

    axios.postRequest({ path: addEventKey, payload, success, error, final });
  },
  getAdminChartKeysList: ({ params, success, error, final }) => {
    const {
      seatsIO: { listAdminChartKeys },
    } = apiPath;

    axios.getRequest({
      path: listAdminChartKeys,
      params,
      success,
      error,
      final,
    });
  },
  getAdminEventKeysList: ({ chartKey, success, error, final }) => {
    const {
      seatsIO: { listAdminEventKeys },
    } = apiPath;

    axios.getRequest({
      path: `${listAdminEventKeys}/${chartKey}`,
      success,
      error,
      final,
    });
  },
  addAdminChartKey: ({ payload, success, error, final }) => {
    const {
      seatsIO: { addAdminChartKey },
    } = apiPath;

    axios.postRequest({
      path: addAdminChartKey,
      payload,
      success,
      error,
      final,
    });
  },
  addAdminEventKey: ({ payload, success, error, final }) => {
    const {
      seatsIO: { addAdminEventKey },
    } = apiPath;

    axios.postRequest({
      path: addAdminEventKey,
      payload,
      success,
      error,
      final,
    });
  },
  eventList: ({ params, success, error ,final}) => {
    const {
      event: { eventList },
    } = apiPath;

    axios.getRequest({ path: eventList, params, success, error ,final});
  },
};

export default programmsOrganizerApi;
